const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class checkAuthApi {

        static async checkAuth() {
            try {
                const response = await fetch(`${API_BASE_URL}/check_auth`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include', // Include cookies in the request
                });
    
                const responseBody = await response.json();
                //console.log('==== //response.status === ', response.status)
                //console.log('=====responseBody======', responseBody.error)
    
                if (response.status === 200) {
                    //return company;
                }
                else if (response.status === 401) {
                    throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
                }
                else {
                    if (responseBody.error.includes('duplicate')) {
                        throw new Error(`Duplicated data entries status ${response.status}`);
                    }
                    else {
                        throw new Error(`${responseBody.error} status ${response.status}`);
                    }
    
                }
            } catch (error) {
                if (error instanceof Error) {
                    throw new Error(`Failed to create customer: ${error.message}`);
                } else {
                    throw new Error('Failed to create customer: An unknown error occurred.');
                }
            }
        }
}
export default checkAuthApi;